import clsx from "clsx";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import classes from "../../styles.module.scss";

import { Filter } from "@components/molecules/filter";
import type {
  ITableCustomSearchProps,
  ITableFilterSearchProps,
} from "@components/organisms/pageTable";
import { TableSearch } from "@components/molecules/tableSearch";
import { Grid } from "@components/atoms/Grid";
import { Button } from "@components/atoms/button";
import { Icon } from "@components/atoms/icons";

export function TableFilterSearch({
  filterProps,
  searchProps,
  action,
  placeholder,
}: ITableFilterSearchProps & ITableCustomSearchProps) {
  const { t } = useTranslation("actions");

  return (
    <div className={clsx(classes.pageTable__filterSearch)}>
      {filterProps?.options && filterProps?.options?.length > 0 && (
        <Filter {...filterProps} />
      )}
      <TableSearch
        onChange={(value) => {
          searchProps?.onChange(value);
        }}
        placeholder={searchProps?.placeholder || placeholder}
        value={searchProps?.value}
      />
      {action && (
        <Grid.Button className={clsx(classes.pageTable__gridButton)}>
          <Link to={action.to}>
            <Button
              mode={"main"}
              icon={<Icon name={"AddSquare"} />}
              label={t(action.label)}
              onClick={() => {
                if (action?.onClick) {
                  action?.onClick?.();
                }
              }}
            />
          </Link>
        </Grid.Button>
      )}
    </div>
  );
}
